var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgForward(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 12,
    viewBox: "0 0 18 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#4A90E2",
    fillRule: "evenodd",
    d: "M.122 6a1 1 0 0 0 1.001 1h12.925l-2.873 2.88a.999.999 0 0 0-.002 1.415c.39.39 1.028.382 1.417-.007l4.576-4.576a1.01 1.01 0 0 0 0-1.424L12.59.712a1 1 0 0 0-1.417-.007c-.39.39-.387 1.024.002 1.414L14.048 5H1.123A.998.998 0 0 0 .122 6z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgForward);
export default __webpack_public_path__ + "static/media/forward.aa6a2a0ce39edc8a64f29deb6fb8c467.svg";
export { ForwardRef as ReactComponent };